import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import CmpModal from "../../Component/Common/ReuseableComponent/CmpModal";
import axios from "axios";
import { getGlobals } from "../../Configs";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HeaderComponent from "./processComponent/HeaderComponent";
import {
  DataGridPro,
  gridRowIdsSelector,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import { vRdxUserInfo } from "../../Redux/roStore";
import PurchaseConsolidationModal from "./PurchaseConsolidationModal";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  getStatusStyleV1,
} from "../../Utility/Utilitys";
import { OpenInNew } from "@mui/icons-material";
import AllocationItemModal from "./processComponent/AllocationItemModal";
import { CmpTypographyField } from "../../Component/Common/ToolBox/ToolBox";
import { confirmAlert } from "react-confirm-alert";
import { he } from "date-fns/locale";

const FreshPurchasePosting = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  const toolbar = {
    color: "#0d73bb",
    display: "flex",
    justifyContent: "space-between",
    minHeight: "40px !important",
    padding: "0px !important",
    marginTop: vMediaQuery ? "2px !important" : "10px !important",
  };

  const [LocationData, setLocationData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);

  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null); // Store full row data
  const [isPopModalDataChanged, setIsPopModalDataChanged] = useState(false);
  const [openActionModal, setOpenActionModal] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);
  const [detailData, setDetailData] = useState([]);
  const [actionHeaderRow, setActionHeaderRow] = useState(null);
  const [openItemAllocationModal, setOpenItemAllocationModal] = useState(false);
  const [allocatedRow, setAllocatedRow] = useState(null); // Store full row data
  const [isDCAllocated, setIsDCAllocated] = useState(false); // Store full row data

  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("All");
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [consolidationTrans, setConsolidationTrans] = useState([]);
  const [transferTrans, setTransferTrans] = useState([]);
  const [sType, setSType] = useState([]);

  const baseURL = getGlobals().API_BASE_URL;
  const vRdxUserInfoObj = vRdxUserInfo();

  const [filterObj, setFilterObj] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date(),
    Loc: LocationData?.length > 0 ? LocationData[0]?.UId : "",
    DC_Purchase: "N",
  });

  const handleLoadBtn = async () => {
    await fLoad(filterObj.Loc);
    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };

  const handleRowClick = (params) => {
    setSelectedRow(params?.row);
    setOpen(true);

    setTimeout(() => {
      document.getElementById("F_Type")?.focus();
    }, 400);
  };

  const apiRef = useGridApiRef();
  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
    });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  const fFilter = () => {
    setOpenFilterModal(true);
  };

  const Actioncolumns = [
    { field: "RP_ItmCd", headerName: "Item Code", width: 90, hide: true },
    { field: "RP_ItmName", headerName: "Item Name", minWidth: 140, flex: 1 },
    {
      field: "isMultiPacking",
      headerName: "Multi-Pack",
      minWidth:55,
     // hide: isDCAllocated ? true : false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => <span>{params.value === true ? "Y" : ""}</span>,
    },
    {
      field: "RP_RequestQty",
      headerName: "Req Qty",
      width: 75,
      type: "number",
      align: "right",
    },
    {
      field: "RP_PurchasedQty",
      headerName: "Purchased Qty",
      width: 110,
      type: "number",
      align: "center",
    },
    {
      field: "RP_ExcessPurchase",
      headerName: "Excess Purchase",
      width: 120,
      type: "number",
      align: "center",
    },
    {
      field: "RP_DCReserved",
      headerName: "DC Reserved",
      width: 100,
      type: "number",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        if (!isDCAllocated) return <span>{params.value}</span>;
        return (
          <TextField
            value={params.value ?? ""}
            onChange={(e) => {
              const newValue = e?.target?.value ?? "";
              handleFieldEdit(params, newValue, "RP_DCReserved");
            }}
            disabled={actionHeaderRow?.DCQtyAllocated === "POST"}
            inputProps={{
              inputMode: "decimal",
              type: "number",
              step: "any",
              min: 0,
            }}
            autoComplete="off"
            sx={{
              width: 100,
              "& .MuiOutlinedInput-input": {
                textAlign: "center",
                padding: "4px 6px",
                fontSize: "12px",
              },
              "& .MuiOutlinedInput-root": {
                //backgroundColor: "#edfaff",
                borderRadius: "6px",
                height: "26px",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "lightgray",
              },
            }}
            size="small"
            variant="outlined"
            onKeyDown={handleKeyDown}
            onWheel={(e) => e.target.blur()} // prevent scroll from changing the value
            // 👇 prevent the grid from taking focus on first click
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            onFocus={(e) => e.stopPropagation()}
            // optional: avoid it becoming a tabbable grid focus target
            tabIndex={-1}
          />
        );
      },
    },
    {
      field: "Qty",
      headerName: "Qty",
      width: 80,
      type: "number",
      align: "center",
      headerAlign: "center",
      hide: isDCAllocated ? true : false,
    },
    {
      field: "RP_PackQty",
      headerName: "Pack Qty",
      width: 80,
      type: "number",
      align: "right",
    },

    {
      field: "AllocatedQty",
      headerName: "Allocated Qty",
      width: 100,
      type: "number",
      align: "center",
      headerAlign: "center",
      hide: isDCAllocated ? true : false,
    },
    {
      field: "BalanceQty",
      headerName: "Balance Qty",
      width: 100,
      type: "number",
      align: "center",
      headerAlign: "center",
      hide: isDCAllocated ? true : false,
    },
  ];

  const fAllocationGetRow = async (row) => {
    setLoadingAction(true);
    try {
      const payload = {
        RP_VocTyp: row?.A_VocTyp,
        RP_VocNo: row?.A_VocNo,
      };
      const data = await axios.post(
        `${baseURL}PurchaseOrder/PUCNS01CONSLReqPur_GETROW`,
        payload
      );
      if (data.status === 200) {
        let GridID = data?.data?.data?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setDetailData(GridID);
      }
    } catch (error) {
      console.error("API Error:", error);
      fAlertToast("FAILED", error?.response?.data?.message || error?.message);
      setDetailData({ status: "error", message: "Failed to fetch data." });
    } finally {
      setLoadingAction(false);
    }
  };
  const handleAction = async (row) => {
    setActionHeaderRow(row);
    fAllocationGetRow(row);
    setOpenActionModal(true);
  };

  const handleActionRowClick = (params) => {
    setAllocatedRow(params?.row);
    setOpenItemAllocationModal(true);

    setTimeout(() => {
      document.getElementById("F_Type")?.focus();
    }, 400);
  };

  const columns = [
    {
      field: "DC_Qty",
      headerName: "DCQty",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      // hide:true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleAction(params.row);
            setIsDCAllocated(true);
          }}
        >
          <OpenInNew fontSize="small" />
        </IconButton>
      ),
    },
    {
      field: "Action",
      headerName: "Allocation",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      // hide:true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleAction(params.row);
            setIsDCAllocated(false);
          }}
        >
          <OpenInNew fontSize="small" />
        </IconButton>
      ),
    },

    {
      field: "A_VocTyp",
      headerName: "A_VocTyp",
      width: 110,
      align: "left",
      hide: true,
    },
    {
      field: "VocName",
      headerName: "Doc.Name",
      flex: 1,
      minWidth: 240,
      align: "left",
    },
    { field: "A_VocNo", headerName: "Doc.No", width: 110, align: "left" },
    {
      field: "A_VocDt",
      headerName: "Doc.Date",
      width: 90,
      align: "left",
      valueFormatter: ({ value }) =>
        moment(value).format("DD/MM/YYYY") == "Invalid date"
          ? ""
          : moment(value).format("DD/MM/YYYY"),
    },

    { field: "LocName", headerName: "Location", width: 160, align: "left" },
    { field: "Deptname", headerName: "Department", width: 200, align: "left" },
    {
      field: "A_DocStat",
      headerName: "Status",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const style = getStatusStyleV1(params.value);
        return (
          <div
            style={{
              ...style,
              padding: "2px 8px",
              borderRadius: "4px",
              textAlign: "center",
              width: "100%",
              fontWeight: "bold",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "Completed",
      headerName: "Completed",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const style = getStatusStyleV1(params.value);
        return (
          <div
            style={{
              ...style,
              padding: "2px 8px",
              borderRadius: "4px",
              textAlign: "center",
              width: "100%",
              fontWeight: "bold",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "DCQtyAllocated",
      headerName: "DC.Qty",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const style = getStatusStyleV1(params.value);
        return (
          <div
            style={{
              ...style,
              padding: "2px 8px",
              borderRadius: "4px",
              textAlign: "center",
              width: "100%",
              fontWeight: "bold",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "Allocated",
      headerName: "Allocated",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const style = getStatusStyleV1(params.value);
        return (
          <div
            style={{
              ...style,
              padding: "2px 8px",
              borderRadius: "4px",
              textAlign: "center",
              width: "100%",
              fontWeight: "bold",
            }}
          >
            {params.value}
          </div>
        );
      },
    },

    {
      field: "CompletedByName",
      headerName: "Completed.By",
      width: 120,
    },
    { field: "A_DC_Purchase", headerName: "DC", width: 60, align: "left" },
  ];

  const fLocation = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    const vRdxUserInfoObj = vRdxUserInfo();

    try {
      const response = await axios.post(
        `${baseURL}PurchaseOrder/Location_List`,
        {
          UserCd: vRdxUserInfoObj?.UserID,
        }
      );
      if (response.status === 200) {
        setLocationData(response?.data?.recordset);
        setFilterObj((prev) => ({
          ...prev,
          Loc: response?.data?.recordset[0]?.UId,
        }));

        fLoad(response?.data?.recordset[0]?.UId);
        loader.style.display = "none";
      }
    } catch (err) {
      console.log(err);
      fAlertToast("FAILED", err?.response?.data?.error || err?.message);
      loader.style.display = "none";
    }
  };
  const fLoad = async (Loc) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    const vRdxUserInfoObj = vRdxUserInfo();
    try {
      const response = await axios.post(
        `${baseURL}PurchaseOrder/PUCNS01CONSLA_Summary_Getrow`,
        {
          FromDt: moment(filterObj.dateFrom).format("MM/DD/YYYY"),
          ToDt: moment(filterObj.dateTo).format("MM/DD/YYYY"),
          DC_Purchase: filterObj.DC_Purchase,
          Loc: Loc ? Loc : filterObj?.Loc,
          CNTRL_PUR: "N",
          UserCd: vRdxUserInfoObj?.UserID,
        }
      );

      if (response.status === 200) {
        setSummaryData(response?.data?.data?.summary);
        loader.style.display = "none";
      }
    } catch (err) {
      console.log(err);
      fAlertToast("FAILED", err?.response?.data?.message || err?.message);
      loader.style.display = "none";
    }
  };

  const fDetail = async () => {
    setLoading(true);

    try {
      const response = await axios.post(`${baseURL}PurchaseOrder/FP_PURCHASE`, {
        docTyp: selectedRow?.A_VocTyp,
        docNo: selectedRow?.A_VocNo,
        TRNSID: type,
      });

      if (response.status === 200) {
        const resp = response?.data?.data;
        setSType(resp?.type);
        setTransferTrans(resp?.transferTrans);
        setPurchaseOrders(resp?.purchaseOrders);
        setConsolidationTrans(resp?.consolidationTrans);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const num = (v) =>
    v === "" || v === null || v === undefined ? 0 : Number(v) || 0;

  const fSave = async (isApprove) => {
    try {
      // validate sequentially; stop at first invalid row
      const hasInvalid = (detailData ?? []).some((r, i) => {
        const reserved = num(r?.RP_DCReserved);
        const purchased = num(r?.RP_PurchasedQty);

        if (reserved > purchased) {
          const code = r?.RP_ItmCd ?? "(no item)";
          fAlertToast(
            "FAILED",
            `DC Reserved should not be greater than Purchased Qty for item ${code} (row ${
              i + 1
            }). Reserved ${reserved} > Purchased ${purchased}`
          );
          return true; // short-circuit: block save
        }
        return false; // keep checking
      });
      if (hasInvalid) return; // block POST
      const details = (detailData ?? []).map((row) => ({
        ItmCd: row.RP_ItmCd,
        DCReserved:
          row.RP_DCReserved === "" || row.RP_DCReserved == null
            ? 0
            : Number(row.RP_DCReserved),
      }));
      const obj = {
        RP_VocTyp: actionHeaderRow?.A_VocTyp,
        RP_VocNo: actionHeaderRow?.A_VocNo,
        isApprove: isApprove,
        details,
      };
      const response = await axios.post(
        `${baseURL}PurchaseOrder/PUCNS01CONSLReqPur_Update`,
        obj
      );
      if (response?.status === 200) {
        if (isApprove === "Y") {
          fAlertToast("SUCCESS", "DC allocation approved Successfully");
          setActionHeaderRow((prev) => ({
            ...prev,
            DCQtyAllocated: "POST",
          }));
          await fLoad(filterObj.Loc);
        } else {
          fAlertToast("SUCCESS", "Saved Successfully");
          fAllocationGetRow(actionHeaderRow);
        }
      }
    } catch (error) {
      console.log(error);
      fAlertToast(
        "FAILED",
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message
      );
    }
  };

  const fDCPost = () => {
    confirmAlert({
      title: "Approve",
      message: "Are you want to approve?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: async () => {
            await fSave("Y");
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  const postApi = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}PurchaseOrder/PUCNS01CONSL_ComparePurVsAlloc_GETROW`,
        fcheck_null_undefine_replace_empty({
          vocTyp: actionHeaderRow?.A_VocTyp,
          vocNo: actionHeaderRow?.A_VocNo,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Allocation approved successfully");
        loader.style.display = "none";
        setActionHeaderRow((prev) => ({
          ...prev,
          Allocated: "POST",
        }));
        await fLoad(filterObj.Loc);
      }
    } catch (error) {
      let errorMessage =
        error?.response?.data?.message?.msg ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `${errorMessage}`);
      loader.style.display = "none";
    }
  };

  const fAllocPost = () => {
    confirmAlert({
      title: "Approve",
      message: "Are you want to approve?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: async () => {
            await postApi();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  const handleFieldEdit = (params, value, fieldName) => {
    setDetailData((prev) => {
      if (!Array.isArray(prev)) return prev ?? [];
      const idx = prev.findIndex((r) => r.id === params.row.id);
      if (idx < 0) return prev;
      const row = prev[idx];
      const parsed = value === "" || value === null ? "" : Number(value);
      const next = [...prev];
      next[idx] = { ...row, [fieldName]: parsed };
      return next;
    });
  };

  const handleKeyDown = (e) => {
    stopGridArrowNavigation(e);
    if (e.key === " ") e.stopPropagation();
  };

  useEffect(() => {
    fLocation();
  }, []);

  return (
    <>
      <Box sx={{ mx: 1.5 }}>
        <Box pt={vMediaQuery ? 0 : 2}>
          {vMediaQuery ? (
            <Grid container>
              <Grid item xs={9}>
                <Typography
                  variant={vMediaQuery ? "subtitle2" : "h6"}
                  gutterBottom
                  color={"primary"}
                  sx={{ fontWeight: 600, mt: 1 }}
                >
                  Fresh Purchase Posting
                </Typography>
              </Grid>
              <Grid item xs={3} textAlign={"right"}>
                <Button
                  variant="contained"
                  sx={{
                    height: "30px",
                    mt: 0.5,
                    textTransform: "capitalize",
                  }}
                  onClick={fFilter}
                >
                  Filter
                </Button>
              </Grid>
            </Grid>
          ) : (
            <>
              <Typography
                variant="h6"
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600 }}
              >
                Fresh Purchase Posting
              </Typography>

              <HeaderComponent
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                handleLoadBtn={handleLoadBtn}
                handlePrint={handlePrint}
                handleExport={handleExport}
                LocationData={LocationData}
                vMediaQuery={vMediaQuery}
              />
            </>
          )}

          <Box
            sx={{
              mt: vMediaQuery ? 1 : 2,
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              height: { xs: "75vh", sm: "70vh", md: "70vh", lg: "70vh" },
              width: "100%",
            }}
          >
            <DataGridPro
              apiRef={apiRef}
              rowHeight={30}
              headerHeight={40}
              rows={summaryData}
              getRowId={(v) => v.A_VocNo}
              columns={columns}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              initialState={{
                pinnedColumns: !vMediaQuery
                  ? { left: ["DC_Qty", "Action"] }
                  : {},
              }}
              sx={{
                border: 1,
                borderColor: "primary.light",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#0d73bb",
                  color: "white",
                },
                "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-pinnedColumnHeaders":
                  {
                    backgroundColor: "#0d73bb",
                    color: "#fff",
                  },
                "& .MuiDataGrid-pinnedColumnHeaders": {
                  zIndex: 2,
                  textAlign: "left",
                },
                "& .MuiDataGrid-pinnedColumns--left": {
                  boxShadow: "4px 0 6px -4px rgba(37, 15, 15, 0.2)",
                },
              }}
              hideFooter
              onRowDoubleClick={handleRowClick}
            />
          </Box>

          {vMediaQuery && (
            <CmpModal
              open={openFilterModal}
              onClose={() => setOpenFilterModal(false)}
              title="Filter"
              width={"95%"}
              height={"auto"}
              component={
                <HeaderComponent
                  closeModal={() => setOpenFilterModal(false)}
                  handleLoadBtn={handleLoadBtn}
                  filterObj={filterObj}
                  setFilterObj={setFilterObj}
                  handlePrint={handlePrint}
                  handleExport={handleExport}
                  LocationData={LocationData}
                  vMediaQuery={vMediaQuery}
                />
              }
            />
          )}
        </Box>

        <PurchaseConsolidationModal
          open={open}
          xCloseModal={() => {
            if (isPopModalDataChanged) {
              fLoad(filterObj.Loc);
              setIsPopModalDataChanged(true);
            }
            setIsPopModalDataChanged(false);
            setOpen(false);
          }}
          xModalfullScreen={vMediaQuery}
          xModalHeight={"85vh"}
          data={selectedRow}
          setSelectedRow={setSelectedRow}
          setIsPopModalDataChanged={setIsPopModalDataChanged}
          fDetail={fDetail}
          transferTrans={transferTrans}
          consolidationTrans={consolidationTrans}
          purchaseOrders={purchaseOrders}
          type={type}
          loading={loading}
          setTransferTrans={setTransferTrans}
          setConsolidationTrans={setConsolidationTrans}
          setPurchaseOrders={setPurchaseOrders}
          setType={setType}
          setLoading={setLoading}
          sType={sType}
        />
      </Box>

      <Drawer
        open={openActionModal}
        anchor="right"
        sx={{
          "& .MuiDrawer-paper": {
            width: {
              xs: "100% !important",
              sm: "90% !important",
              md: "85% !important",
              lg: isDCAllocated ? "60% !important" : "75% !important",
            },
          },
        }}
      >
        <Box role="presentation" sx={{ marginTop: "40px", paddingX: "20px" }}>
          <Toolbar sx={toolbar}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => setOpenActionModal(false)}
                aria-label="close"
                sx={{
                  color: "#0d73bb",
                  fontSize: "20px !important",
                  paddingLeft: "0px",
                }}
              >
                <ArrowBackIcon />
              </IconButton>
              <Typography
                variant="h5"
                sx={{
                  fontSize: vMediaQuery ? "16px !important" : "20px !important",
                  marginTop: "4px",
                  marginLeft: "16px",
                }}
              >
                {isDCAllocated ? "DC Allocation" : "Allocation"}
              </Typography>
            </div>

            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setOpenActionModal(false)}
              aria-label="close"
              sx={{ color: "#0d73bb", fontSize: "20px !important" }}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>

          {loadingAction ? (
            <Box display="flex" justifyContent="center" p={4}>
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              {/* Summary Header */}
              {actionHeaderRow && (
                <Box
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                    p: 1,
                    borderRadius: 1,
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <Grid container spacing={vMediaQuery ? 0.5 : 1}>
                    <Grid item xs={12} sm={5.5} md={3.5}>
                      <Grid container>
                        <Grid item xs={3} sm={3.5} md={3}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            Doc.No
                          </Typography>
                        </Grid>
                        <Grid item xs={1} sm={0.5} md={1}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            :
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={7} md={8}>
                          <Typography variant="subtitle2" fontWeight={600}>
                            {actionHeaderRow?.A_VocNo}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6.5} md={5}>
                      <Grid container>
                        <Grid item xs={3} sm={2.5} md={3}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            Doc.Name
                          </Typography>
                        </Grid>
                        <Grid item xs={1} sm={0.5} md={1}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            :
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={9} md={8}>
                          <Typography variant="subtitle2" fontWeight={600}>
                            {actionHeaderRow?.VocName}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={5.5} md={3.5}>
                      <Grid container>
                        <Grid item xs={3} sm={3.5} md={3}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            Doc.Date
                          </Typography>
                        </Grid>
                        <Grid item xs={1} sm={0.5} md={1}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            :
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={7} md={8}>
                          <Typography variant="subtitle2" fontWeight={600}>
                            {moment(actionHeaderRow?.A_VocDt).format(
                              "DD/MM/YYYY"
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6.5} md={3.5}>
                      <Grid container>
                        <Grid item xs={3} sm={2.5} md={3}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            Location
                          </Typography>
                        </Grid>
                        <Grid item xs={1} sm={0.5} md={1}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            :
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={9} md={8}>
                          <Typography variant="subtitle2" fontWeight={600}>
                            {actionHeaderRow?.LocName}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={5.5} md={5}>
                      <Grid container>
                        <Grid item xs={3} sm={3.5} md={3}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            Department
                          </Typography>
                        </Grid>
                        <Grid item xs={1} sm={0.5} md={1}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            :
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={6.5} md={8}>
                          <Typography variant="subtitle2" fontWeight={600}>
                            {actionHeaderRow?.Deptname}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6.5} md={3.5}>
                      <Grid container>
                        <Grid item xs={3} sm={2.5} md={3}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            Status
                          </Typography>
                        </Grid>
                        <Grid item xs={1} sm={0.5} md={1}>
                          <Typography
                            variant="subtitle2"
                            color={"primary.main"}
                            fontWeight={600}
                          >
                            :
                          </Typography>
                        </Grid>
                        <Grid item xs={8} sm={9} md={8}>
                          <Typography variant="subtitle2" fontWeight={600}>
                            {isDCAllocated
                              ? actionHeaderRow?.DCQtyAllocated
                              : actionHeaderRow?.Allocated}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={4.5}
                    display="flex"
                    justifyContent="flex-end"
                  >
                    {isDCAllocated ? (
                      <>
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={() => fSave("N")}
                          sx={{ marginRight: 1 }}
                          disabled={actionHeaderRow?.DCQtyAllocated === "POST"}
                        >
                          Save
                        </Button>
                        <Button
                          size="small"
                          variant="contained"
                          color="success"
                          onClick={fDCPost}
                          disabled={actionHeaderRow?.DCQtyAllocated === "POST"}
                        >
                          Approve
                        </Button>
                      </>
                    ) : (
                      <Button
                        size="small"
                        variant="contained"
                        color="success"
                        disabled={actionHeaderRow?.Allocated === "POST"}
                        onClick={fAllocPost}
                      >
                        Approve
                      </Button>
                    )}
                  </Grid>
                </Box>
              )}
              <Box
                sx={{
                  height: { xs: "55vh", sm: "65vh", md: "67vh" },
                  width: "100%",
                }}
              >
                <DataGridPro
                  rows={detailData}
                  columns={Actioncolumns}
                  getRowId={(row) => row.RP_ItmCd}
                  hideFooter
                  disableRowSelectionOnClick
                  columnHeaderHeight={32}
                  rowHeight={32}
                  headerHeight={40}
                  onRowClick={!isDCAllocated ? handleActionRowClick : ""}
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#0d73bb",
                      color: "white",
                      fontWeight: "bold",
                    },
                    "& .MuiDataGrid-cell": {
                      padding: "4px",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontSize: "12px",
                      textAlign: "center",
                    },
                    "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                      color: "#24292e",
                    },
                    "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked":
                      {
                        color: "#0298f5",
                      },
                    "& .MuiDataGrid-row.reject-row": {
                      backgroundColor: "#ffe5e5 !important",
                    },
                  }}
                />
              </Box>
              <Box textAlign={"center"}>
                {" "}
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => setOpenActionModal(false)}
                  sx={{ width: "10%" }}
                >
                  Close
                </Button>{" "}
              </Box>
            </Box>
          )}
        </Box>
      </Drawer>

      <CmpModal
        open={openItemAllocationModal}
        onClose={() => setOpenItemAllocationModal(false)}
        title="Item Allocation Model"
        width={"80%"}
        height={"85vh"}
        component={
          <AllocationItemModal
            open={openItemAllocationModal}
            closeModal={() => setOpenItemAllocationModal(false)}
            handleLoadBtn={handleLoadBtn}
            itemData={allocatedRow}
            data={actionHeaderRow}
            vMediaQuery={vMediaQuery}
          />
        }
      />
    </>
  );
};

export default FreshPurchasePosting;

const stopGridArrowNavigation = (e) => {
  const blocked = [
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "PageUp",
    "PageDown",
  ];
  if (blocked.includes(e.key)) e.stopPropagation();
};
